import { type ReactElement } from 'react';
import { useRouter } from 'next/router';

import styles from './date-index-detail.module.scss';
import { Font } from '@utmb/design-system/text/font';
import { ColorTypesEnum } from '@utmb/types/colors';
import { getColorStyle } from '@utmb/utils/colors';

export interface DateIndexDetailProps {
    /** ISO date of the race. */
    dateIso: string;
    /** Age of the result in months at the calculation date. */
    monthsAge: number;
    /** Age degradation percentage applied (matrix value: a positive value reduces the score). */
    degradationPct: number;
}

function formatPct(value: number): string {
    const rounded = Math.round(value * 10) / 10;
    return rounded.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
}

export function DateIndexDetail({ dateIso, monthsAge, degradationPct }: DateIndexDetailProps): ReactElement {
    const { locale } = useRouter();

    // A negative degradation increases the score (bonus); a positive one reduces it (malus).
    const isBonus = degradationPct < 0;
    const effectPct = -degradationPct;

    const monthYear = new Date(dateIso).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
    const label = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);

    return (
        <div className={styles.dateIndexDetail}>
            <Font.FuturaMedium as="span" className={styles.year} desktop="16" mobile="16">
                {label}
            </Font.FuturaMedium>
            <div className={styles.ponderation + ' ' + (isBonus ? styles.bonus : styles.malus)}>
                <div className={styles.monthCount}>
                    <Font.FuturaMedium as="span" desktop="12" mobile="12">
                        + {monthsAge} mois
                    </Font.FuturaMedium>
                </div>
                <div className={styles.percentage}>
                    <Font.FuturaMedium as="span" desktop="12" mobile="12" color={getColorStyle(ColorTypesEnum.WHITE)}>
                        {effectPct >= 0 ? '+' : '-'} {formatPct(Math.abs(effectPct))}%
                    </Font.FuturaMedium>
                </div>
            </div>
        </div>
    );
}
